import { PreSetupHook } from '../urPlayerManager'

const AUDIO_FORMAT = 'audio'

const getPreloadMode: PreSetupHook = (_id, config) =>
  config.format === AUDIO_FORMAT ? { preload: 'auto' } : {}

export default getPreloadMode
